<template>
    <div class='login-container mobile' style='padding: 0 !important;'>
        <div class='mobile-header'>
            <div class='back-content' @click='onBack'>
                <img src='/img/icons/ic_page_prev.jpg' />
            </div>
            <div class='mobile-header-title'>계약서 발송 내역</div>
        </div>
        <div class='contract-content' style='padding: 0'>
            <div class='top-search-area mobile-search-container'>
                <div class='zoom-image'></div>
                <input v-model='keyword' placeholder="이름, 연락처 입력" type='text' style='flex: 1; padding-left: 44px;'
                       @keyup.enter='onSearch'>
                <button class='com-btn' @click='onSearch'>검색</button>
            </div>
            <div style='padding: 30px 15px 20px 15px; min-height: 60vh' v-show='contractList.length > 0'>
                <div class='table-top-container' style='margin-bottom: 10px'>
                    <div style='display: flex; align-items: center; justify-content: space-between; width: 100%'>
                        <div class='table-top-count' style='font-size: 13px'>총 <span class='blue'>{{ this.pagingInfo.totalItems }}</span> 건</div>
                        <div class='table-top-count' style='font-size: 12px; margin-left: auto; display: flex' @click='onChangeSortType()'><img src='/img/icons/ic_sort.png' style='width: 14px; margin-right: 3px;' /><span>발송순</span></div>
                    </div>
                </div>
                <table class='com-table'>
                    <thead>
                    <tr>
                        <th class='mobile-table' style='text-align: left'>회원명</th>
                        <th class='mobile-table' style='text-align: left'>계약서명</th>
                        <th class='mobile-table'>상태</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for='(t, index) in contractList' :key='index'>
                        <td class='mobile-table' style='text-align: left'>
                            <div style='width: 27vw'>
                                <span class='link txt-underline' @click='onUserDetail(index)'>{{t.c_center_name}}</span><br />{{t.c_center_phone | phoneNumberFilter}}
                            </div>
                        </td>
                        <td class='mobile-table' style='text-align: left;'>
                            <div style='width: 32vw'>
                                <div class='link txt-underline line-blind' @click='onContractDetail(index)'>{{t.ct_contract_title}}</div>
                            </div>
                        </td>
                        <td class='mobile-table' :style='"color: " + `${t.cs_status == "R" ? "#00C7E5" : ((t.cs_status == "C" || t.cs_status == "N") ? "#f64444" : "black")}`'>
                            <div style='width: 24vw'>
                                {{t.cs_status | getContractSendStatus}}
                            </div>
                        </td>
                    </tr>
                    <tr v-if='contractList.length === 0'>
                        <td colspan='100'>발송된 계약서 내역이 없습니다.</td>
                    </tr>
                    </tbody>
                </table>
                <b-pagination v-model='pagingInfo.page' :per-page='pagingInfo.limit'
                              :total-rows='pagingInfo.totalItems' align='center'
                              aria-controls='my-table' first-class='first'
                              last-class='last' next-class='next'
                              prev-class='prev'
                              @change="handlerPagenation($event)"></b-pagination>
            </div>
            <div style='padding: 30px 15px 20px 15px; min-height: 60vh' v-show='contractList.length == 0'>
                <div style='width: 100%; text-align: center'>
                    <img class='login-image' />
                </div>
                <div class='login-contractor'>발송된 계약서 내역이 없습니다.</div>
            </div>
            <div style='background-color: #f0f0f0; width: 100%; padding: 25px 20px;'>
                <div class='footer-note'>유의 사항</div>
                <div class='footer-desc'><div>•</div>&nbsp;&nbsp;<div>APP에서는 회원에게 발송한 계약서만 확인 가능합니다.</div></div>
                <div class='footer-desc'><div>•</div>&nbsp;&nbsp;<div>계약서는 최근 3개월 내역까지 노출합니다.</div></div>
                <div class='footer-desc'><div>•</div>&nbsp;&nbsp;<div>3개월 이전 및 기타 상세내역은 PC버전에서 확인 가능합니다.</div></div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import moment from 'moment';
import { getSendTemplateList } from '@/assets/js/api';

export default {
    name: 'AdminContractList',
    props: {},
    computed: {
    },
    components: {
    },
    data() {
        return {
            contractList: [],
            sortType: true,
            keyword: "",
            pagingInfo: {...pagingInfo},
        };
    },
    mounted() {
        this.uid = window.localStorage.getItem('uid');

        this.init();
    },
    methods: {
        async init() {
            this.onSearchList();
        },

        onBack() {
            this.$router.back();
        },

        onUserDetail(index) {

        },

        onContractDetail(index) {
            this.$router.push({
                path: `/mobile/admin/contract/detail/${this.contractList[index].cst_id}`
            });
        },

        onChangeSortType() {
            this.sortType = !this.sortType;
            this.onSearchList();
        },

        onSearch() {
            this.pagingInfo.page = 1;

            this.onSearchList();
        },

        // 페지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;

            this.onSearchList();
        },

        getDocumentList() {
            // 스웨거: Lesson Manage Paging 목록 조회
            let params = {
                startDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                searchStr: this.keyword,
                sortColumn: this.sortType ? "cs_cre_dt" : "cs_status",
                sortType: "DESC",
                ...this.pagingInfo,
            };

            return getSendTemplateList(params)
        },

        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        async onSearchList() {
            try {
                this.isLoading = true;

                const { data } = await this.getDocumentList();
                this.setPageParams(data);
                this.contractList = data.items;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
    },
};
</script>
